import React from "react";

const XCircle = ({ onClick }) => {
  return (
    <div className="absolute -top-8 -right-8 p-4 hover:cursor-pointer" onClick={onClick}>
      <img src="https://cdn.shopify.com/s/files/1/0663/3298/3452/files/XCircle.png?v=1738090529" />
    </div>
  );
};

export default XCircle;
